import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { stringify } from 'qs'

import { AuthContext } from 'utils/auth'
import RequestCore, { lsGetWithToken } from 'utils/request'
import { useCustomSWR } from 'utils/hooks/fetchers'
import { selectWebview } from 'store/webview/webviewSlice'
import { getEnvInfoQs } from 'utils/helpers/device-info'

const useStaleMe = (token, webview = {}) => {
  return useCustomSWR(
    () =>
      !!token
        ? [
            `/users/me?${stringify(getEnvInfoQs(webview))}`,
            RequestCore.getToken(),
          ]
        : null,
    lsGetWithToken,
    { dedupingInterval: 1000 * 60 * 60 * 6 }
  )
}

export const useLoginData = () => {
  const { token, appId, webviewAuthFinished } = useContext(AuthContext)
  const isAuth = !!token
  const webview = useSelector(selectWebview)
  const { data, mutate, isLoading, error } = useStaleMe(token, webview)

  return {
    loggedIn: !!token,
    me: data?.me,
    error: error && !data,
    token,
    appId,
    mutate,
    isLoading: !webviewAuthFinished || (isAuth ? isLoading : false),
    isServiceAdmin: !isLoading && data?.me?.role === 'serviceAdmin',
    isVender: !isLoading && data?.me?.role === 'vender',
    isSinyi:
      !isLoading &&
      (data?.me?.role === 'sinyiIntranet' || data?.me?.role === 'ta3'),
    isCustomer: !isLoading && data?.me?.role === 'customer',
  }
}
